import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useSite } from "../lib/SiteContext";

const FaqSection = () => {
  const { content } = useSite();
  const f = content?.faqs || {};
  const items = f.items || [];
  return (
    <section id="faq" className="section-padding bg-muted/40" data-testid="faq-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline mb-4">{f.overline}</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-primary leading-[1.05] text-balance">
              {f.title}
            </h2>
            <p className="text-muted-foreground mt-6 leading-relaxed">
              Have a question that isn&rsquo;t covered? Send us a message — we usually reply within an hour.
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {items.map((it, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                  <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-primary hover:no-underline py-6">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
